"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = exports.selectType = exports.multipleType = exports.singleType = void 0;
var singleType = 'Single';
exports.singleType = singleType;
var multipleType = 'Multiple';
exports.multipleType = multipleType;
var selectType = 'Select';
exports.selectType = selectType;
var types = [singleType, multipleType, selectType];
exports.types = types;